/* import __COLOCATED_TEMPLATE__ from './qa-status-separator.hbs'; */
/* RESPONSIBLE TEAM: team-fin-qa */
import templateOnlyComponent from '@ember/component/template-only';

const QaStatusSeparator = templateOnlyComponent();
export default QaStatusSeparator;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::ConversationsTable::TableCells::QaStatusSeparator': typeof QaStatusSeparator;
    'inbox2/conversations-table/table-cells/qa-status-separator': typeof QaStatusSeparator;
  }
}
